import { ModuleRegistry, ClientSideRowModelModule } from "ag-grid-community";
import { 
    LicenseManager,
    IntegratedChartsModule,
    ValidationModule,
    MenuModule,
    GridChartsModule,
    RangeSelectionModule,
    SetFilterModule,
    MultiFilterModule,
    GroupFilterModule
} from 'ag-grid-enterprise';
import { 
    TextFilterModule,
    NumberFilterModule,
    DateFilterModule,
    CustomFilterModule 
} from 'ag-grid-community';
import { LicenseManager as AgChartsLicenseManager } from 'ag-charts-enterprise';

// Set license key for both AG Grid and AG Charts Enterprise
const LICENSE_KEY = "Using_this_{AG_Charts_and_AG_Grid}_Enterprise_key_{AG-075932}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{G&T_Actionable_Intelligence_LLP}_is_granted_a_{Multiple_Applications}_Developer_License_for_{1}_Front-End_JavaScript_developer___All_Front-End_JavaScript_developers_need_to_be_licensed_in_addition_to_the_ones_working_with_{AG_Charts_and_AG_Grid}_Enterprise___This_key_has_not_been_granted_a_Deployment_License_Add-on___This_key_works_with_{AG_Charts_and_AG_Grid}_Enterprise_versions_released_before_{25_February_2026}____[v3]_[0102]_MTc3MTk3NzYwMDAwMA==85eb64471bb1c258abdffa21a62a9dbc";

// Set license for AG Grid Enterprise
LicenseManager.setLicenseKey(LICENSE_KEY);

// Set license for AG Charts Enterprise
AgChartsLicenseManager.setLicenseKey(LICENSE_KEY);

// Register AG Grid Enterprise Modules
ModuleRegistry.registerModules([
    ClientSideRowModelModule,
    IntegratedChartsModule,
    GridChartsModule,
    RangeSelectionModule,
    MenuModule,
    ValidationModule,
    TextFilterModule,
    NumberFilterModule,
    DateFilterModule,
    SetFilterModule,
    MultiFilterModule,
    GroupFilterModule,
    CustomFilterModule
]);
